export default __webpack_public_path__ + "media/storefront/features/hymns/hymns/SaudiArabia-05df260f6b1c1c2c6f0c93a7598da1df.mp3";